import React, { Component } from 'react'

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }
  openDropDown = () => {
    if (this.props.onhover) {
      this.setState({
        isOpen: true
      })
    }
  }
  closeDropDown = () => {
    this.setState({
      isOpen: false
    })
  }
  toggleDropDown = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  render() {
    let { isOpen } = this.state
    let { buttonComponent, children, dropdownStyle } = this.props
    return (
      <div
        style={{ position: 'relative' }}
        onMouseEnter={this.openDropDown}
        onMouseLeave={this.closeDropDown}
        onClick={this.toggleDropDown}
      >
        <div onClick={this.toggleDropDown}>{buttonComponent}</div>
        {isOpen ? (
          <div
            style={{ position: 'absolute', top: '100%', ...dropdownStyle }}
            onClick={this.closeDropDown}
          >
            {children}
          </div>
        ) : null}
      </div>
    )
  }
}

export default Dropdown
